import React, { Component } from "react";
import style from "../../assets/css/modules/claims/claims-summary-container.css";
import ClaimsSummaryDesktopRow from "./ClaimsSummaryDesktopRow";
import ClaimsSummaryMobileRow from "./ClaimsSummaryMobileRow";
import ClaimsSummaryFormat2DesktopRow from "./ClaimsSummaryFormat2DesktopRow";
import ClaimsSummaryShortfallRow from "./ClaimsSummaryShortfallRow";
import Tooltip from "../shared/Tooltip";
import Store from "../../content/Store";
import { PopupBlockerWarning } from "../../features/popups/PopupBlockerWarning";
import { connect } from "react-redux";

export class ClaimsSummaryContainer extends Component {
  render() {
    const {
      arePopupsBlocked,
      isFormat2,
      claimSummary = {},
      membershipNumber
    } = this.props;

    return (
      <React.Fragment>
        {arePopupsBlocked ? (
          <div className="row">
            <div className="col-12">
              <PopupBlockerWarning />
            </div>
          </div>
        ) : null}
        <div className={`row ${style.claimSummaryRow} hidden-md-down ${this.props.isFormat2?style.rowBoxShadow:" "}`}>
          {isFormat2 ? (
            <ClaimsSummaryFormat2DesktopRow
              membershipNumber={membershipNumber}
              claimSummary={claimSummary}
            />
          ) : (
            <ClaimsSummaryDesktopRow claimSummary={claimSummary} />
          )}
        </div>
        {isFormat2 && claimSummary.IsMemberShortFall ? (
          <div className={"row pb-3 hidden-md-down "+style.rowBoxShadow}>
            <ClaimsSummaryShortfallRow />
          </div>
        ) : null}
        <div
          className={
            `row ${style.claimSummaryRow} hidden-lg-up ${style.rowPaddings}
             ${this.props.isFormat2?style.rowBoxShadow:" "}`
          }
        >
          <ClaimsSummaryMobileRow
            membershipNumber={membershipNumber}
            claimSummary={claimSummary}
            isFormat2={isFormat2}
          />
        </div>
        {isFormat2 && claimSummary.IsMemberShortFall ? (
          <div className="hidden-lg-up">
            <Tooltip
              text={Store.Claims.PaymentNeededTooltipText}
              customStyle="mt-1"
            />
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export const mapStateToClaimsSummaryContainer = ({
  popupBlockerReducer = {}
}) => {
  return {
    arePopupsBlocked: popupBlockerReducer.arePopupsBlocked
  };
};

export default connect(mapStateToClaimsSummaryContainer)(
  ClaimsSummaryContainer
);
